// import image from "../images/header.jpg";
const PData = [
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/web.png",
    name: "Click Here",
    category: "Web",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/web1.png",
    name: "Click Here",
    category: "Web",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/web2.png",
    name: "Click Here",
    category: "Web",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  
  {
    id: "https://docfindproject.netlify.app/",
    image: "./img/ui1.png",
    name: "Click Here",
    category: "UI/UX",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/ui2.png",
    name: "Click Here",
    category: "UI/UX",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/ui3.png",
    name: "Click Here",
    category: "UI/UX",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },

  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/graphic.png",
    name: "Click Here",
    category: "Graphic",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/graphic2.png",
    name: "Click Here",
    category: "Graphic",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/graphic3.png",
    name: "Click Here",
    category: "Graphic",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/shopify1.png",
    name: "Click Here",
    category: "Shopify",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/shopify2.png",
    name: "Click Here",
    category: "Shopify",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/shopify3.png",
    name: "Click Here",
    category: "Shopify",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/ecom1.png",
    name: "Click Here",
    category: "E-Commerce",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/ecom2.png",
    name: "Click Here",
    category: "E-Commerce",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
  {
    id: "https://syedmustafa.rf.gd/website/",
    image: "./img/ecom3.png",
    name: "Click Here",
    category: "E-Commerce",
    description: "Our approach is cross-functional collaboration and constant improvement.",
  },
];
export default PData;
